export default __webpack_public_path__ + "static/media/aboutHero.34ad8acb.png";